export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const MODE = process.env.REACT_APP_MODE ?? "";
export const TINY_MCE_API_KEY = process.env.REACT_APP_TINY_MCE_API_KEY ?? "";
